import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import { ConfigService } from "app/core/api/config.service";
import { AppConfig, DemoConfig } from 'app/core/model/trjireh-model';

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  searchMobileActive = false;

  ordenServicio = '';

  demoConfig = new DemoConfig();
  appConfig = new AppConfig();

  constructor(private router: Router,
            private configService: ConfigService) { }

  ngOnInit() {

    this.appConfig = this.configService.getAppConfig();

    // this.configService.getConfig().subscribe(c => {
    //   const conf = c.filter((a: { name: string; }) => a.name == 'demo');
    //   if (conf.length > 0){
    //       this.demoConfig = conf[0].data;
    //   }

    //   const app = c.filter((a: { name: string; }) => a.name == 'app');
    //   if (app.length > 0){
    //     this.appConfig = app[0].data;
    //   }
    // });
  }

  toggleSearchMobile() {
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    
    this.router.navigate(['/ordenservicio/listaros', this.ordenServicio]);

  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/header.component.ts